module.exports = __webpack_public_path__ + "static/img/product-17.a92478b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-17.png
// module id = N7Dz
// module chunks = 0